import { invokeApi } from "../../utils/tdlib/inVokeApi";

export const logout_api = async () => {
  const requestObj = {
    path: `api/app_api/logout`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _auth_api = async (data) => {
  const requestObj = {
    path: `api/developer_auth/login_developer_auth`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _init_without_token_api = async () => {
  const requestObj = {
    path: `api/init/init_without_auth`,
    method: "GET",
  };
  return invokeApi(requestObj);
};
export const _get_documents_api = async () => {
  const requestObj = {
    path: `api/general_settings/fetch_general_settings_client`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};




